export function isResultMultiPoi(poiResult) {
    return poiResult.type && poiResult.listId === undefined; // exclude favourites items that have '.type' parameter as well 
}